import React, { useState } from 'react';
import MyIhsan from './MyIhsan';
import Saved from './Saved';
import Settings from './Settings';

const SEGMENTS = [
  { id: 'me', label: 'Me' },
  { id: 'saved', label: 'Saved' },
  { id: 'settings', label: 'Settings' }
];

/**
 * Profile — everything personal, reached from the avatar in the top bar.
 *
 * Saved used to be a bottom tab of its own. It moved in here because the bottom
 * bar now spends its five slots on Home, Moments, Scan, Activity and Messages,
 * and a bookmark list is something a member goes looking for deliberately
 * rather than something they switch to mid-task.
 */
export default function Profile({
  onNavigate,
  onTopTabChange,
  onOpenExploreItem,
  onOpenRewards,
  onOpenTracker,
  initialMeTab = 'all',
}) {
  const [segment, setSegment] = useState('me');
  // Saved's category filter is local to this screen so it cannot leak back out
  // into Home the way the old shared top-tab did.
  const [savedFilter, setSavedFilter] = useState('all');

  return (
    <div className="min-h-screen bg-background" data-testid="profile-page">
      <div className="px-4 pt-3 pb-1 desktop-shell">
        <div className="inline-flex rounded-full bg-muted p-1" role="tablist">
          {SEGMENTS.map((seg) => (
            <button
              key={seg.id}
              type="button"
              role="tab"
              aria-selected={segment === seg.id}
              data-testid={`profile-segment-${seg.id}`}
              onClick={() => setSegment(seg.id)}
              className={`px-5 py-1.5 rounded-full text-sm font-semibold transition-colors ${
                segment === seg.id ? 'bg-white text-primary shadow-sm' : 'text-muted-foreground'
              }`}
            >
              {seg.label}
            </button>
          ))}
        </div>
      </div>

      {segment === 'me' && (
        <MyIhsan
          onNavigate={onNavigate}
          onTopTabChange={onTopTabChange}
          onOpenRewards={onOpenRewards}
          initialMeTab={initialMeTab}
        />
      )}
      {segment === 'saved' && (
        <Saved
          activeTopTab={savedFilter}
          onTopTabChange={setSavedFilter}
          onOpenExploreItem={onOpenExploreItem}
        />
      )}
      {segment === 'settings' && (
        <Settings onNavigate={onNavigate} onOpenTracker={onOpenTracker} />
      )}
    </div>
  );
}
